import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
} from 'react-router-dom';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';

import './App.css';
import logo from './Logo.png';
import AppStore from './AppStore.svg';

import Beta from './Beta';
import Footer from './Footer';
import Home from './Home';
import Support from './Support';
import ThankYou from './ThankYou';

function App() {
  return (
    <Router>
      <Navbar collapseOnSelect expand="sm" bg="secondary" >
        <Navbar.Brand as={NavLink} to="/">
          <Image rounded src={logo} alt="logo" width="30" height="30" className="d-inline-block align-top" />
          {` `}
          CTManager
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link as={NavLink} to="/support">
              Submit Support Request
            </Nav.Link>
          </Nav>
          <Nav>
          <Navbar.Text>
            <a href="https://apps.apple.com/us/app/chameleontiny-manager/id1601341565">
              <img src={AppStore} alt="App Store" />
            </a>
            </Navbar.Text>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Container fluid="md" className="mt-3">
        <Routes>
          <Route path="/beta" element={<Beta />} />
          <Route path="/support" element={<Support />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/" index element={<Home />} />
        </Routes>
      </Container>
      <Footer />
    </Router>
  );
}

export default App;
